import { render } from "./PaperRetrieve.vue?vue&type=template&id=5570d7f8&scoped=true"
import script from "./PaperRetrieve.vue?vue&type=script&lang=js"
export * from "./PaperRetrieve.vue?vue&type=script&lang=js"

import "./PaperRetrieve.vue?vue&type=style&index=0&id=5570d7f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5570d7f8"]])

export default __exports__